module.exports = __webpack_public_path__ + "static/media/phd_gatenga5.ccc343c6.jpg";